import { BrandingLogoSizes } from './BrandingLogoSizes';

export const brandingSites = {
    citizens: {
        logo: 'citizens-Logo.png',
        sizes: {
            [BrandingLogoSizes.Large]: { width: 297, height: 171 },
            [BrandingLogoSizes.Small]: { width: 75, height: 66 },
            [BrandingLogoSizes.XSmall]: { width: 94, height: 51 },
        },
    },
    default: {
        logo: 'default-Logo.png',
        sizes: {
            [BrandingLogoSizes.Large]: { width: 268, height: 79 },
            [BrandingLogoSizes.Small]: { width: 38, height: 19 },
            [BrandingLogoSizes.XSmall]: { width: 168, height: 50 },
        },
    },
    demo: {
        logo: 'demo-Logo.png',
        sizes: {
            [BrandingLogoSizes.Large]: { width: 181, height: 50 },
            [BrandingLogoSizes.Small]: { width: 98, height: 28 },
            [BrandingLogoSizes.XSmall]: { width: 284, height: 51 },
        },
    },
    dev: {
        logo: 'dev-Logo.png',
        sizes: {
            [BrandingLogoSizes.Large]: { width: 141, height: 50 },
            [BrandingLogoSizes.Small]: { width: 77, height: 28 },
            [BrandingLogoSizes.XSmall]: { width: 256, height: 51 },
        },
    },
    mha: {
        logo: 'MHA-Logo.png',
        sizes: {
            [BrandingLogoSizes.Large]: { width: 111, height: 109 },
            [BrandingLogoSizes.Small]: { width: 86, height: 28 },
            [BrandingLogoSizes.XSmall]: { width: 263, height: 54 },
        },
    },
    oakbend: {
        logo: 'oakbend-Logo.png',
        sizes: {
            [BrandingLogoSizes.Large]: { width: 279, height: 66 },
            [BrandingLogoSizes.Small]: { width: 86, height: 28 },
            [BrandingLogoSizes.XSmall]: { width: 263, height: 54 },
        },
    },
    stvincent: {
        logo: 'stvincent-Logo.png',
        sizes: {
            [BrandingLogoSizes.Large]: { width: 361, height: 39 },
            [BrandingLogoSizes.Small]: null,
            [BrandingLogoSizes.XSmall]: null,
        },
    },
    staging: {
        logo: 'staging-Logo.png',
        sizes: {
            [BrandingLogoSizes.Large]: { width: 268, height: 79 },
            [BrandingLogoSizes.Small]: { width: 129, height: 28 },
            [BrandingLogoSizes.XSmall]: { width: 324, height: 51 },
        },
    },
};
